import { render } from "./ServicesList.vue?vue&type=template&id=5037d023"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5037d023"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5037d023', script)) {
    api.reload('5037d023', script)
  }
  
  module.hot.accept("./ServicesList.vue?vue&type=template&id=5037d023", () => {
    api.rerender('5037d023', render)
  })

}

script.__file = "src/views/services/ServicesList.vue"

export default script